import { PostSearchFiltersDto } from '@libs/dto';
import { CompensationType, CommitmentType } from '@libs/types';

export const getFilterParams = (searchParams: URLSearchParams) => {
  const filters: PostSearchFiltersDto = {};
  
  if (searchParams.has('keyword')) {
    filters.keyword = searchParams.get('keyword') || undefined;
  }
  
  if (searchParams.has('location')) {
    filters.location = searchParams.get('location') || undefined;
  }
  
  if (searchParams.has('radius')) {
    const radius = searchParams.get('radius');
    filters.radius = radius ? Number(radius) : undefined;
  }
  
  if (searchParams.has('compensationMin')) {
    const compensationMin = searchParams.get('compensationMin');
    filters.compensationMin = compensationMin ? Number(compensationMin) : undefined;
  }
  
  if (searchParams.has('compensationMax')) {
    const compensationMax = searchParams.get('compensationMax');
    filters.compensationMax = compensationMax ? Number(compensationMax) : undefined;
  }
  
  if (searchParams.has('compensationType')) {
    const typeValue = searchParams.get('compensationType');
    if (typeValue === 'hourly') {
      filters.compensationType = CompensationType.HOURLY;
    } else if (typeValue === 'weekly') {
      filters.compensationType = CompensationType.WEEKLY;
    } else if (typeValue === 'monthly') {
      filters.compensationType = CompensationType.MONTHLY;
    } else if (typeValue === 'yearly') {
      filters.compensationType = CompensationType.YEARLY;
    }
  }
  
  if (searchParams.has('commitmentType')) {
    const typeValue = searchParams.get('commitmentType');
    if (typeValue === 'full-time') {
      filters.commitmentType = CommitmentType.FULL_TIME;
    } else if (typeValue === 'part-time') {
      filters.commitmentType = CommitmentType.PART_TIME;
    } else if (typeValue === 'contract') {
      filters.commitmentType = CommitmentType.CONTRACT;
    } else if (typeValue === 'temporary') {
      filters.commitmentType = CommitmentType.TEMPORARY;
    } else if (typeValue === 'volunteer') {
      filters.commitmentType = CommitmentType.VOLUNTEER;
    } else if (typeValue === 'seasonal') {
      filters.commitmentType = CommitmentType.SEASONAL;
    } else if (typeValue === 'internship') {
      filters.commitmentType = CommitmentType.INTERNSHIP;
    }
  }
  
  if (searchParams.has('benefits')) {
    const benefits = searchParams.get('benefits');
    if (benefits) {
      filters.benefits = benefits.split(',');
    }
  }
  
  if (searchParams.has('startDate')) {
    const startDate = searchParams.get('startDate');
    if (startDate) {
      try {
        filters.startDate = new Date(startDate);
      } catch (error) {
        console.error('Invalid date format:', error);
      }
    }
  }

  return filters;
};

export default getFilterParams;
